var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#1847CA",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20c.281-.969.906-1.844 1.531-2.688l.469-.656c.625-.906 1-1.968 1-3.125C21 10.47 18.531 8 15.5 8a5.488 5.488 0 0 0-5.5 5.5c0 1.188.344 2.25.969 3.156l.469.657c.624.843 1.25 1.718 1.562 2.687h5zm-2.5 4c1.375 0 2.5-1.094 2.5-2.5V21h-5v.5c0 1.406 1.094 2.5 2.5 2.5zM13 13.5c0 .281-.25.5-.5.5a.494.494 0 0 1-.5-.5c0-1.906 1.563-3.5 3.5-3.5.25 0 .5.25.5.5 0 .281-.25.5-.5.5a2.487 2.487 0 0 0-2.5 2.5z",
    fill: "#1847CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.0dfb803a6db68c307d476db4468300e9.svg";
export { ForwardRef as ReactComponent };